type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
};

const FacebookLoveReactionBadge = (props: Props) => {
  const { width = '18', height = '18', viewBox = '0 0 18 18' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
    >
      <defs>
        <linearGradient id="fbLoveGrad" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#F33E58" />
          <stop offset="100%" stopColor="#E2293C" />
        </linearGradient>
      </defs>
      <circle cx="9" cy="9" r="9" fill="url(#fbLoveGrad)" />
      <path
        d="M9 13.7c-.18 0-.36-.07-.49-.2L4.96 9.95C3.93 8.95 3.7 7.39 4.4 6.13c.7-1.27 2.2-1.85 3.55-1.4.42.14.81.38 1.13.71.31-.33.7-.57 1.13-.71 1.34-.45 2.85.14 3.54 1.4.7 1.27.47 2.83-.55 3.83l-3.55 3.55c-.13.13-.31.2-.49.2z"
        fill="#FFFFFF"
      />
    </svg>
  );
};

export default FacebookLoveReactionBadge;
